export enum EnvironmentTypeEnum {
  Local = 'Local',
  Dev = 'Dev',
  PreProd = 'Pre-prod',
  Prod = 'Prod'
}
